var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAverageAum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#662D91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.45 15.4999C21.075 15.4999 21.75 14.8749 21.15 12.8249C20.7438 11.4437 19.5563 10.2562 18.175 9.84993C16.125 9.24993 15.5 9.92493 15.5 11.5499V13.3499C15.5 14.8749 16.125 15.4999 17.375 15.4999H19.45Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 17.1874C19.9186 20.0812 17.1436 22.1812 13.9874 21.6687C11.6186 21.2874 9.7124 19.3812 9.3249 17.0124C8.81865 13.8687 10.9061 11.0937 13.7874 10.5062",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageAum);
export default __webpack_public_path__ + "static/media/average-aum.5b3943767743cd873c2dd24be65a3b38.svg";
export { ForwardRef as ReactComponent };